(function () {'use strict';}());

angular.module('app')
  .controller('CauseEffectController', function ($scope,$q,$document,$compile,AppService, $timeout,$rootScope) {
  	var trace = angular.trace;

  	$scope.$watch("currentMinigame",onMinigameSelection);
    $scope.$watch("currentPageIndex",onPageSelection);
    $scope.cards = [];
    $scope.side = [];
    $scope.attempts = 0;
    $scope.maxAttempts = 0;
    $scope.orderClasses = [];
    $scope.win = false;
    $scope.readyCheck = true;
    $scope.dragging = false;
    $scope.evaluating = false;
    $scope.timelineTitle = null;

    $scope.sortableOptions = {
        cursor: "grabbing",
        connectWith: ".destination",
        tolerance: "pointer",
        revert:true,
        opacity:0.9,
        start:clearFeedback,
        stop:function(){
            $scope.$apply(function(){$scope.dragging = false;});
        },
        receive: function(e, ui){
             $scope.$apply(function(){$scope.readyCheck = true;});

            var length = $document.find("ul.destination").find("li").length;
            var classes = $document.find("div.destination-bg").attr("class");
            classes = classes.replace(/count-\d{1}/gim,"");
            $document.find("div.destination-bg").attr("class",classes);
            $document.find("div.destination-bg").addClass("count-"+length);
        }
    };


    $scope.sideCardOptions = {
        connectWith: ".source",
        disabled: false,
        start: clearFeedback,
        stop:function(){
            $scope.$apply(function(){$scope.dragging = false;});
        },
        revert:true,
        receive: function(e, ui){
            var length = $document.find("ul.destination").find("li").length;
            if(length > 4)  $scope.$apply(function(){$scope.readyCheck = false;});
            if(length > 5)  ui.sender.sortable("cancel");

            var classes = $document.find("div.destination-bg").attr("class");
            classes = classes.replace(/count-\d{1}/gim,"");
            $document.find("div.destination-bg").attr("class",classes);
            $document.find("div.destination-bg").addClass("count-"+length);

            $rootScope.$emit("audio","Place_Card");

        }
    };


    $scope.evaluateCardOrder = function(){
        var cards = $document.find(".ce .destination li");
        var discard = $document.find(".ce .source li");
        var correct,link,win;
        var lastCard = null;
        if($scope.win === true) return;
        if($scope.evaluating === true) 
        {
            $rootScope.stopAudio();
            return clearFeedback();
        }
        cards.each(function(index){
            var card = $(this);
            var currentOrder = parseInt(card.data("order"));
            var prevOrder = (index > 0) ? parseInt(cards.eq(index-1).data("order")) : -1;
            trace("index: " + index, "pi: " + parseInt(cards.eq(index-1).data("order")), "currentOrder: " +currentOrder, "prevOrder: " + prevOrder);
            link = index > 0 && prevOrder > 0 ? (currentOrder - prevOrder === 1) : 0;
            correct = (index + 1) === parseInt(card.data("order"));
            card.addClass(correct ? "correct":"incorrect");

            if(lastCard && link && !card.hasClass()) lastCard.addClass("link-right");
            if(link) card.addClass("link-left");

            lastCard =  card;
        });

        discard.addClass(parseInt(discard.data("order")) ? "incorrect":"correct");
        $document.find(".ce").addClass("sorted");
        $scope.win = $document.find(".ce .incorrect").length ? false : true;
        $scope.evaluating = true;
        if($scope.win === false) startNewAttempt();
        else {
            $rootScope.$emit("audio","Win_Game");
            $scope.setGeocacheCallback($scope.continuePlaying);
            var evt = {
                eventCategory: "GRTT: Mini Game",
                eventLabel:  "GRTT: " + $scope.currentMinigame.title
            };
            gtag("event", "GRTT: end - complete", evt);
        }
    };


    $scope.continuePlaying = function(){
        var deferred = $q.defer();
        deferred.promise.then(returnToMenu);
        $scope.currentLocation.isCorrect = true;
        $scope.setCurrentArtifact($scope.currentLocation.artifact,deferred);
        $scope.setScalingPrevention(false);
        var evt = {
            eventCategory: "GRTT: Mini Game",
            eventLabel:  "GRTT: " + $scope.currentMinigame.title
        };
        gtag("event", "GRTT: end - incomplete", evt);
    };

    function startNewAttempt(){
        $scope.attempts ++;
        $scope.updateTelepathy($scope.attempts);
        $rootScope.requestAudio("Losing_Psychic_Power").then(function(){
            $rootScope.requestAudio("Magnify_On");
        });

        if($scope.attempts < $scope.maxAttempts) return;

        var deferred = $q.defer();
        var resetCallback = null;
       
        $document.find(".ce").removeClass("sorted");

        var evt = {
            eventCategory: "GRTT: Mini Game",
            eventLabel:  "GRTT: " + $scope.currentMinigame.title
        };
        gtag("event", "GRTT: end - incomplete", evt);


        deferred.promise.then(returnToMenu);
        $rootScope.$emit("audio","Lose_Game");
        $scope.drawDownHours(4);
        $scope.currentLocation.isCorrect = false;
        $scope.attempts = 0;
        trace("scope hours remaining: " + $scope.hoursRemaining);
         if($scope.hoursRemaining >= 4){
          resetCallback = $q.defer();
          resetCallback.promise.then(reset);
          trace("reset callback");
        }

        $scope.setCurrentFeedback("current feedback object", deferred, resetCallback);
    }


    function clearFeedback(e,ui){
        if(e && ui) $rootScope.$emit("audio","Dragging_Card");
        $scope.$apply(function(){$scope.dragging = true;});
        $scope.evaluating = false;
        $document.find(".ce").removeClass("sorted");
        $document.find(".ce .correct, .ce .incorrect, .ce.link").removeClass("link link-left link-right correct incorrect");
    }

  	function onMinigameSelection(value){
  		if(!value) return;
  		if(value.type !== "cause-effect") return;
        reset(value);
  	}
    function onPageSelection(value){
        if(!value || value !== $scope.PAGE_MINIGAME) return;
        if($scope.currentMinigame.type !== "cause-effect") return;
        $scope.setScalingPrevention(true);
      //  $scope.setGeocacheCallback($scope.continuePlaying);
    }

    function reset(game){
        if(!$rootScope.CEHelpView){
            $rootScope.CEHelpView = true;
            $scope.help();
        }
        $scope.cards = [];
        $scope.side = [];
        $scope.attempts = 0;
        $scope.feedback = null;
        $scope.maxAttempts = $scope.currentMinigame.maxAttempts;
        $scope.updateTelepathy($scope.attempts);
        $scope.dates = $scope.currentMinigame.dates;
        $scope.timelineTitle = $scope.currentMinigame.timelineTitle;

        //Manage the activity manually; canceling sort breaks ui-sortable directive
        $document.find(".ce.minigame li").remove();

        $timeout(initializeCardOrder,0);
        var evt = {
            eventCategory: "GRTT: Mini Game",
            eventLabel:  "GRTT: " + $scope.currentMinigame.title
        };
        gtag("event", 'GRTT: start', evt);
    }

    function initializeCardOrder(){
        var orders = $scope.currentMinigame.orders;
        var order = orders[Math.floor(Math.random()*orders.length)];
        $scope.cards = $scope.currentMinigame.cards.concat().sort(sortCards.bind(order));
        $timeout(initializeSortable,0);
    }

    function initializeSortable(){
        $document.find("ul.source").sortable($scope.sortableOptions);
        $document.find("ul.destination").sortable($scope.sideCardOptions);
        $document.find("ul.source li").click(onItemClick);
    }

    function onItemClick(e){
        if($scope.dragging || $scope.transforming) return;
        var factor = 2.5;
        var card = $(this);
        var offset = card.offset();
        var html = card.html();
        var clone = $("<div class='clone flip-container'>"+html+"</div>");
        var container = $document.find(".zoom");
        var width = card.outerWidth();
        var height = card.outerHeight();
        var containerOffsetTop = parseInt($("#app-container").css("marginTop"));
        var containerOffsetLeft = parseInt($("#app-container").css("marginLeft"));

        var targetTop = (container.height() - (factor*height))/2;
        var targetLeft = (container.width() - (factor*width))/2;


        $scope.$apply(function(){
            $rootScope.$emit("audio","Flip_Card");
        });
        
        clone
            .css("top",(offset.top - containerOffsetTop)+"px")
            .css("left",(offset.left - containerOffsetLeft) + "px")
            .css("position","absolute")
            .width(width)
            .height(height);
        trace("clicked");
        $timeout(function(){
            clone
            .addClass("hover")
            .delay(500)
            .animate({top:targetTop,left:targetLeft,width:width*factor,height:height*factor},{duration:750,specialEasing:"easeInOut",complete:function(){
                clone.find("span").animate({opacity:1},{duration:500});
                $scope.transforming = false;
                $(document).on("click.dismiss",dismiss.bind({card:card}));
                $(document).on("touchend.dismiss",dismiss.bind({card:card}));
            }});
        },250);

        container.append(clone);
        $document.find(".ce").addClass("zooming");
        card.css("opacity",0);
        $scope.transforming = true;
    }

    function dismiss(){
        var container = $document.find(".zoom");
        $scope.transforming = true;
        var card = this.card;
        $(document).off("click.dismiss");
        $(document).off("touchend.dismiss");
        card.css("opacity",1);
        container.animate({opacity:0},{duration:500,complete:function(){
            container.find(".clone").remove();
             $document.find(".ce").removeClass("zooming");
             container.css("opacity",1);
             $scope.transforming = false;
        }});

        $scope.$apply(function(){
            $rootScope.$emit("audio","Flip_Card_Return");
        });

        
    }

    function sortCards(a,b){
        var indexA = this.indexOf(a.index);
        var indexB = this.indexOf(b.index);
        if(indexA > indexB) return 1;
        if(indexA < indexB) return -1;
        return 0;
    }

    function returnToMenu(){
      $scope.setCurrentPage($scope.currentLocation.isCorrect ? $scope.PAGE_ARTIFACT_COLLECTION : $scope.PAGE_MAP);
    }

  });
